import Scriba from 'react-scriba';

export class DataReservation {


    static _ficheReservation_Simple(idOperation, idReservation) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation
        };
        var url = "api/Fiche/FicheReservation_Simple";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _miseAJourReservation(idOperation, idReservation, reservation) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation,
            "reservation": reservation
        };
        var url = "api/MAJDonnees/MiseAJourReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDonneesReservation(idOperation, idReservation) {
        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation
        };
        var url = "api/Get/GetDonneesReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementCreation(idOperation, idReservation, idLotCommercial, reservation, listContacts, listCommercialisateurs) {

        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation,
            "idLotCommercial": idLotCommercial,
            "reservation": reservation,
            "listSouhaitsContact": listContacts,
            "listCommercialisateurs": listCommercialisateurs
        };

        var url = "api/MAJDonnees/CreationReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionReservation(idOperation, idReservation) {

        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation
        };

        var url = "api/MAJDonnees/SuppressionReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onDesistementReservation(idOperation, idReservation, desistement) {

        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation,
            "desistement": desistement
        }

        var url = "api/MAJDonnees/DesistementReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionContactReservation(idOperation, idReservation, idContact) {

        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation,
            "idContact": idContact
        }

        var url = "api/MAJDonnees/SuppressionContactReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionCommercialisation = (idOperation, idReservation, loginCompte) => {
        const objet = { idOperation, idReservation, loginCompte };
        const url = "api/MAJDonnees/SuppressionCommercialisation";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementFicheReservation(idOperation, idReservation) {

        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation
        };

        var url = "api/Fiche/FicheReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementListeDesReservations = (idOperation, inclureVentesEnBloc = false) => {
        const objet = { idOperation, inclureVentesEnBloc };
        const url = "api/Liste/ListeDesRESERVATIONS";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementTitreReservation(idOperation, idReservation) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation
        }

        var url = "api/Fiche/FicheReservation_Titre";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheReservation_HistoriqueEtat(idOperation, idReservation) {

        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation
        };

        var url = "api/Fiche/FicheReservation_HistoriqueEtat";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheReservation_ChargementDuContactSelectionne(idContact, idSouhait) {

        let objet = {
            "idContact": idContact,
            "idSouhait": idSouhait
        };

        var url = "api/Fiche/FicheReservation_ChargementDuContactSelectionne";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementEcheancierValide(idOperation, idReservation, estValide) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation,
            "estValide": estValide
        };
        var url = "api/MAJDonnees/EnregistrementEcheancierValide";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onRemplacementEcheancier(idOperation, idReservation, idEcheancier) {
        const objet = { idOperation, idReservation, idEcheancier };
        const url = "api/MAJDonnees/RemplacementEcheancier";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementDroitsReservation(idOperation, idReservation) {
        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation
        };
        var url = "api/Droit/ListeDesDroitsFicheReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementListeAppelsDeFond = (filtres, sortedColumn, isSortedDescending, facteurNbreEnregistrement, pageIndex) => {
        const objet = { filtres, sortedColumn, isSortedDescending, facteurNbreEnregistrement, pageIndex };
        const url = "api/Liste/ListeDesAppelsDeFonds";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };
}